import React, { memo } from 'react';
import { useLink } from '@yme/hooks/useLink';
export function ButtonLinkWrapperComponent({ children, buttonLink, onClick, className, }) {
    const { LinkComponent } = useLink({
        children,
        className,
        buttonLink,
        onClick,
    });
    if (buttonLink) {
        return React.createElement(LinkComponent, null);
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
}
export const ButtonLinkWrapper = memo(ButtonLinkWrapperComponent);
ButtonLinkWrapper.displayName = 'ButtonLinkWrapper';
